import { Injectable } from '@angular/core';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class AccessLogService {

  constructor(private http: HttpClient) { }
    
      getList(requestData:RequestData): Observable<any> {
        return this.http.post(environment.baseUrl+'/shop/reports/get-access-log', requestData);
    
      }
    
    

      downloadExcel(requestData: any): Observable<Blob> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
       // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL
    
        return this.http.post(environment.baseUrl + '/shop/reports/export-access-log', requestData, { headers, responseType: 'blob' })
          .pipe(
            //catchError(this.handleError)
          );
    
      }

      
  getStations(): Observable<any>{
    let search={"search":{"filters":{"column":[],"scope":{"limit":10,"offset":0}},"sort":[]}};
    return this.http.post(environment.baseUrl+'/shop/terminal/get', search);
  }
  getUsers(): Observable<any>{
    let search={"search":{"filters":{"column":[],"scope":{"limit":1000,"offset":0}},"sort":[]}};
    return this.http.post(environment.baseUrl+'/user/get', search);
  }
    
   getFunctionNames(): Observable<any>{
    let search={"search":{"filters":{"column":[],"scope":{"limit":10,"offset":0}},"sort":[]}};
    return this.http.post(environment.baseUrl+'/shop/reports/get-function-names', search);
  }
    
  
}
